import { render, staticRenderFns } from "./WidgetProductReviewsHorizontalScrollMobile.vue?vue&type=template&id=0b3d338a"
import script from "./WidgetProductReviewsHorizontalScrollMobile.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsHorizontalScrollMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports